export default {"src":"/_next/static/media/simplicity-icon.8c85f86d.svg","height":93,"width":103,"blurWidth":0,"blurHeight":0};